module.exports = __webpack_public_path__ + "static/KOFFIA_2026_Logo-0a13e6715bbab713213a41d502a9a3e1.svg";